<script setup lang="ts">

const props = defineProps({
  price: {
    type: Number,
    required: true,
  },
  isBpcBuyable: {
    type: Boolean,
    required: false,
    default: true,
  },
  isBpcpBuyable: {
    type: Boolean,
    required: false,
    default: true,
  },
  isProcessing: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits({
  buyWithBpc() { },
  buyWithBpcp() { }
})

function buyWithBpc() {
  emit('buyWithBpc')
}

function buyWithBpcp() {
  emit('buyWithBpcp')
}
</script>

<template>
  <div class="md:flex grid justify-center gap-4 py-4 px-8 grid-rows-1 w-full bg-bfh-sub-light">
    <button :disabled="!isBpcpBuyable" @click="buyWithBpcp" class="!w-52 md:!w-1/5">
      <fa-icon v-if="isProcessing" :icon="['fal', 'spinner']" spin />
      {{ $t('trade.buyByPoint', { price }) }}
    </button>
    <button :disabled="!isBpcBuyable" @click="buyWithBpc" class="!w-52 md:!w-1/5">
      <fa-icon v-if="isProcessing" :icon="['fal', 'spinner']" spin />
      <img src="/images/i_icon_hmv.png" style="height: 100%;padding: 5px;">
      {{ $t('trade.buyByFt', { price }) }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
button {
  @extend %btn-primary;
}
</style>
